import { BuildedSaveButtonComponent, SaveComponentButtons } from './_props'
/* eslint-disable import/prefer-default-export */

export const getSaveComponentButtons = ({ saveButton, cancelButton, deleteButton }: SaveComponentButtons) => {
    const buttons: BuildedSaveButtonComponent[] = []
    if (deleteButton)
        buttons.push({
            ...deleteButton,
            type: 'DELETE',
            label: 'Supprimer',
            displayed: deleteButton.displayed !== undefined ? deleteButton.displayed : true,
        })
    if (cancelButton)
        buttons.push({
            ...cancelButton,
            type: 'CANCEL',
            label: 'Annuler',
            displayed: cancelButton.displayed !== undefined ? cancelButton.displayed : true,
        })
    if (saveButton)
        buttons.push({
            ...saveButton,
            type: 'SAVE',
            label: 'Enregistrer',
            displayed: saveButton.displayed !== undefined ? saveButton.displayed : true,
        })

    return buttons
}
